import { render, staticRenderFns } from "./home.vue?vue&type=template&id=60aa3f3c&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=60aa3f3c&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=60aa3f3c&prod&scoped=true&lang=scss"
import style2 from "./home.vue?vue&type=style&index=2&id=60aa3f3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa3f3c",
  null
  
)

export default component.exports